var _defs, _path, _path2, _path3, _path4, _circle, _path5, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteToEmployeePortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.52 43.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.972 16.958v-4.275a5.075 5.075 0 00-5.075-5.075H8.002a5.075 5.075 0 00-5.075 5.075v13.611a5.075 5.075 0 005.075 5.075h12.849"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M4.181 12.761l13.149 7.06 13.716-7.627"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.972 16.958v-4.275a5.075 5.075 0 00-5.075-5.075H8.002a5.075 5.075 0 00-5.075 5.075v13.611a5.075 5.075 0 005.075 5.075h12.849"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M4.181 12.761l13.149 7.06 13.716-7.627"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 33.346,
    cy: 26.92,
    r: 4.048
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M40.65 36.522v-.727a3.844 3.844 0 00-3.845-3.845h-6.918a3.844 3.844 0 00-3.845 3.845v.727"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 30.743,
    cy: 35.681,
    r: 1.445
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteToEmployeePortal);
export default __webpack_public_path__ + "static/media/inviteToEmployeePortal.4fa9a7a0a1a0279e48e5d552fd79adb3.svg";
export { ForwardRef as ReactComponent };